import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisciplinaComAvaliacoes } from '../models/portal.models';

@Component({
  selector: 'app-relatorio-geral',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './relatorio-geral.html',
  styleUrls: ['./relatorio-geral.scss']
})
export class RelatorioGeralComponent {
  // Recebe a lista de disciplinas do componente pai
  @Input() disciplinasComAvaliacoes: DisciplinaComAvaliacoes[] = [];
  @Input() anoLetivoId: number | null = null;
  @Input() alunoId: number | null = null;
  @Input() carregando = false;

  constructor() {}
}
